import { SxProps, Theme } from "@mui/material";

export const root: (incomingSx?: SxProps<Theme>) => SxProps<Theme> = (
  incomingSx
) => ({
  justifySelf: "center",
  alignSelf: "center",
  ...incomingSx,
});
